<button
  mat-stroked-button
  fxFlex="100"
  fxFlex.xs="98"
  fxFlex.md="20"
  class="buttonWidth ellipseButton"
  color="{{ filtersData.name_employee.length != 0 ? 'primary' : 'gray' }}"
  matTooltip="{{ employeesText | titlecase }}"
  matTooltipPosition="above"
  [matTooltipDisabled]="!employeesText"
>
  <div class="filter-persons-container">
    <div
      class="person-filter"
      fxLayout="row"
      fxLayoutAlign="space-between center"
    >
      <div fxLayout="row" [matMenuTriggerFor]="menuYears">
        <div fxLayoutAlign="center center" *ngIf="!employeesText">
          <span class="person-text">Employees</span
          ><span class="material-icons font-size-16"> arrow_drop_down </span>
        </div>
        <div fxLayoutAlign="start center" *ngIf="employeesText">
          <span class="person-text"
            >{{ employeesText | slice: 0:10 | titlecase }}...</span
          >
        </div>
      </div>
      <div
        *ngIf="filtersData.name_employee.length > 0"
        (click)="resetFilters()"
        class="remove-filter"
      >
        <mat-icon>close</mat-icon>
      </div>
    </div>
    <mat-menu #menuYears="matMenu" class="menu-event-filters">
      <span class="filter-by-employee"><b>Filter by</b></span>
      <hr class="line-card" />
      <div class="card-scroll">
        <div
          class="employee-container text_card"
          fxLayout="row"
          fxLayoutAlign="start"
          *ngFor="let employee of employeeList"
        >
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="selectPerson(employee.id)"
            [checked]="employee.selected"
          >
            <span class="employee-name">{{ employee.name | titlecase }}</span>
          </mat-checkbox>
        </div>
      </div>
    </mat-menu>
  </div>
</button>
